<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('producttypefile_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-producttypefile-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td>{{ $t('qualitycheck.product.producttypefiletype') }}</td>
              <td>
                  <span v-if="item['type']">{{ item['type'].name }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ $t('menu.product') }}</td>
              <td>
                <ul v-for="(object, attr) in item['valueType']" :key="attr">
                  <li>
                    <span >{{ object }}</span>
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('global.language') }}</strong></td>
              <td>
                {{ item['language'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.file') }}</strong></td>
              <td>
                                    <v-btn
                                         v-if="item['file']"
                                         color="secondary"
                                         class=""
                                         @click="downloadFileByObject(item)"
                                       >
                                         {{ $t('global.download') }}
                                         <v-icon
                                           right
                                           dark
                                         >mdi-download
                                         </v-icon>
                                       </v-btn>
              </td>
              <td><strong>{{ $t('profile.public') }}</strong></td>
              <td>
                <span v-if="item.public" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';


const servicePrefix = 'Producttypefile';

export default {
  name: 'ProducttypefileShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('producttypefile', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('producttypefile', ['find']),

  },
  methods: {
    ...mapActions('producttypefile', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
